import CssBaseline from '@mui/material/CssBaseline'
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
  createTheme,
} from '@mui/material/styles'

export { ThemeProvider }

const maPrimaryHex = '#1a4d99'
const maSecondaryHex = '#be2c82'

const capoTheme = createTheme({
  palette: {
    secondary: {
      main: maSecondaryHex,
    },
  },

  typography: {
    h1: {
      color: maPrimaryHex,
      fontFamily: 'Aller',
      fontSize: '48px',
      fontWeight: 600,
    },

    h2: {
      color: maPrimaryHex,
      fontFamily: 'Aller',
      fontSize: '34px',
      fontWeight: 600,
      margin: '40px 0 40px 24px',
    },

    h4: {
      color: maPrimaryHex,
      fontFamily: 'Aller',
      fontSize: 20,
      fontWeight: 200,
    },

    caption: {
      opacity: 0.75,
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          height: '100%',
        },

        body: {
          background: '#f0f0f0',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          height: '100%',

          '& > #root': {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
          },
        },
      },
    },

    MuiButtonBase: {
      defaultProps: {
        disableRipple: process.env.NODE_ENV === 'test',
      },
    },

    MuiDialog: {
      defaultProps: {
        slotProps: {
          transition: {
            onExited: undefined,
            timeout: {
              enter: 225,
              exit: 0,
            },
          },
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          boxSizing: 'content-box',
          borderColor: 'rgba(0, 0, 0, 0.1)',
        },

        head: {
          color: 'rgba(45, 63, 88, 0.55)',
        },
      },
    },

    MuiAutocomplete: {
      defaultProps: {
        size: 'small',
      },
    },

    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
  },
})

const ThemeProvider = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={capoTheme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  )
}
